import { literal, nullable, number, object, string } from "superstruct";

import { INSTAGRAM_POST_TAG_LINK_TYPE } from "../constants";

const InstagramPostLinkTagSchema = object({
    id: number(),
    mediaId: nullable(number()),
    coordinateX: number(),
    coordinateY: number(),
    type: literal(INSTAGRAM_POST_TAG_LINK_TYPE),
    link: object({
        title: string(),
        linkUrl: string(),
        linkImageUrl: string(),
    }),
});

export default InstagramPostLinkTagSchema;
